import React from 'react';

function XCircle(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.3056 7.80808C15.5496 7.56399 15.9453 7.56397 16.1894 7.80803C16.4064 8.02498 16.4305 8.36176 16.2618 8.60535L16.1895 8.69192L12.8818 12L16.1902 15.308C16.4343 15.5521 16.4344 15.9478 16.1903 16.1919C15.9734 16.4089 15.6366 16.433 15.393 16.2643L15.3064 16.192L11.998 12.8839L8.69032 16.1919C8.44625 16.436 8.05053 16.436 7.80643 16.192C7.58946 15.975 7.56534 15.6382 7.73407 15.3946L7.80639 15.3081L11.114 12.0001L7.80558 8.69197C7.56149 8.4479 7.56147 8.05217 7.80553 7.80808C8.02248 7.59111 8.35926 7.56699 8.60285 7.73572L8.68941 7.80803L11.9979 11.1161L15.3056 7.80808Z" />
      <path
        clipRule="evenodd"
        d="M11.9984 2C6.47567 2 1.99835 6.47732 1.99835 12C1.99835 17.5227 6.47567 22 11.9984 22C17.521 22 21.9984 17.5227 21.9984 12C21.9984 6.47732 17.521 2 11.9984 2ZM3.24835 12C3.24835 7.16768 7.16603 3.25 11.9984 3.25C16.8307 3.25 20.7484 7.16768 20.7484 12C20.7484 16.8323 16.8307 20.75 11.9984 20.75C7.16603 20.75 3.24835 16.8323 3.24835 12Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default XCircle;
